import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { FieldListResponseData } from "../../types/enum";

export const getData = async () => {
  const { data } = await api.get<FieldListResponseData>(`/fields`);

  return data;
};

export const useFields = (): QueryObserverBaseResult<FieldListResponseData> => {
  const { data, ...props } = useQuery(queryKeys.fields(), () => getData());

  return { data, ...props };
};
